/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets UAApplicationFormIdentifier from api:
 * /v1/ua/sd_coc_application_form
 *
 * @param {string} changeType.
 * @param {any} callback function to call once this function has finished
 */
const fetchSdCocApplicationFormUtil = (changeType, callback) => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sd_coc_application_form?changeType=${changeType}`,
    models.UAApplicationFormIdentifier
  );
};

/**
 * Gets SDExternalUserCOCStatus from api:
 * /v1/ua/sd_externaluser_coc_status
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchSdExternaluserCocStatusUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sd_externaluser_coc_status`,
    models.SDExternalUserCOCStatus
  );
};

/**
 * Deletes from api:
 * /v1/ua/application_form/{application_form_id}
 *
 * @param {string} application_form_id.
 * @param {any} callback function to call once this function has finished
 */
const deleteApplicationFormByApplicationFormIdUtil = (application_form_id, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/application_form/${application_form_id}`;
  RESTService.del(url, (success, response) => {
    callback(success, response);
  });
};

export {
  fetchSdCocApplicationFormUtil,
  fetchSdExternaluserCocStatusUtil,
  deleteApplicationFormByApplicationFormIdUtil,
};
